(() => {
  const getIndex = (node) => {
    let i = 1;
    const tagName = node.tagName;

    while (node.previousSibling) {
      node = node.previousSibling;
      if (
        node.nodeType === 1
        && tagName.toLowerCase() === node.tagName.toLowerCase()
      ) {
        i += 1;
      }
    }
    return i;
  };

  const generateSelector = (elem) => {
    if (!elem) {
      return;
    }

    let pathSelector;

    while (elem.tagName && elem.tagName !== 'HTML') {
      // selector path

      const attributes = !pathSelector ? elem.getAttributeNames()
        .filter((attr) => {
          switch (true) {
            default:
              return false;

            case attr.startsWith('aria-'):
            case attr.toLowerCase().indexOf('-id') > -1:
            case attr.toLowerCase().indexOf('-itemnumber') > -1:
              return true;
          }
        })
        // eslint-disable-next-line no-loop-func
        .map((attr) => {
          const value = elem.getAttribute(attr);
          return value ? `[${attr}="${value}"]` : `[${attr}]`;
        }).join('') : '';
      const classNames = Array.from(elem.classList).join('.');
      const idName = elem.id;
      const index = getIndex(elem);

      pathSelector = `${elem.localName}${attributes ? `${attributes}` : ''}${classNames ? `.${classNames}` : ''}${idName ? `#${idName}` : ''}:nth-of-type(${index})${pathSelector ? `>${pathSelector}` : ''}`;

      elem = elem.parentNode;
    }

    // eslint-disable-next-line consistent-return
    return pathSelector;
  };

  document.addEventListener('click', (e) => {
    if (window.swinger.user.isLoggedIn()) {
      return;
    }

    const elem = window.swinger.eventHub.getTarget(e).closest('[data-authentication-required]');

    if (!elem) {
      return;
    }

    window.swinger.$('[data-authentication-required]').forEach((elem) => { elem.removeAttribute('data-invoker'); });
    elem.setAttribute('data-invoker', '');
    window.swinger.authenticationRequiredElement = elem;

    const actionToExecuteAfterLogin = {
      where: window.location.pathname,
      clickedElementCSSPath: generateSelector(elem),
    };

    window.swinger.storage.set('swinger-action-to-execute-after-login', actionToExecuteAfterLogin);

    elem.classList.add('swinger-data-authentication-required--error');
    window.setTimeout(() => {
      elem.classList.remove('swinger-data-authentication-required--error');
    }, 500);

    e.preventDefault();
    e.stopImmediatePropagation();
  });

  const update = (elem) => {
    const attributes = {
      // eslint-disable-next-line
      'role': 'button',
      'aria-controls': 'swinger-popover-cta-register',
      'aria-expanded': 'false',
      'aria-haspopup': 'dialog',
      'aria-describedby': 'swinger-data-authentication-required__description',
    };

    if (!window.swinger.user.isLoggedIn()) {
      if (elem.hasAttribute('data-previous-set')) {
        return;
      }
      elem.setAttribute('data-previous-set', '');
      Object.keys(attributes).forEach((key) => {
        const previousValue = elem.getAttribute(key);
        if (previousValue) {
          elem.setAttribute(`data-previous-${key}`, previousValue);
        }
        const value = attributes[key];
        elem.setAttribute(key, value);
      });
    } else {
      Object.keys(attributes).forEach((key) => {
        const previousValue = elem.getAttribute(`data-previous-${key}`);
        elem[previousValue ? 'setAttribute' : 'removeAttribute'](key, previousValue);
        elem.removeAttribute(`data-previous-${key}`);
      });
      elem.removeAttribute('data-previous-set');
    }
  };

  window.swinger.observer.initialize('[data-authentication-required]', (elem) => {
    document.addEventListener('swinger.user:authchange', () => {
      update(elem);
    });

    update(elem);
  }, false);
})();
